export let septemberAbbreviatedLowercase = "fMhbFe";
export default {septemberAbbreviatedLowercase};